// API pública del modo demo (ver state.ts para el contexto general).

import { installDemoBackend } from "./install";
import { demoFlagPersisted, markActive, persistDemoFlag } from "./state";

export { DEMO_TOKEN, isDemoActive, exitDemo } from "./state";
export { isDemoCode } from "./backend";

/** Arranca el shim de red del demo. Idempotente. */
export function startDemo(): void {
  markActive();
  persistDemoFlag();
  installDemoBackend();
}

/**
 * Arranca el demo si corresponde: deep-link /demo o flag persistido (recarga).
 * Debe llamarse ANTES de que cualquier hook pida datos, para que el shim ya esté puesto.
 * Devuelve true si el demo quedó activo.
 */
export function maybeStartDemo(): boolean {
  if (typeof window === "undefined") return false;
  const onDemoPath = window.location.pathname.startsWith("/demo");
  if (!onDemoPath && !demoFlagPersisted()) return false;
  startDemo();
  return true;
}
